import { useWindowLocation } from 'hooks/common/useWindowLocation';

export const usePublicForm = () => {
  const { search } = useWindowLocation();

  const getRequiredDataFromURL = () => {
    let fromQR = undefined;
    let linkID = undefined;
    let hasPrefill = false;
    let formID = undefined;
    let tenantID = undefined;
    let equipmentID = undefined;
    if (search) {
      const fromQRMatch = /from_QR=([^?&]*)/.exec(search);
      if (fromQRMatch) fromQR = fromQRMatch[1];
      const linkIDMatch = /link_id=([^?&]*)/.exec(search);
      if (linkIDMatch) linkID = linkIDMatch[1];
      const hasPrefillMatch = /has_prefill=([^?&]*)/.exec(search);
      if (hasPrefillMatch) hasPrefill = hasPrefillMatch[1] === 'true';
      const formIDMatch = /form_id=([^?&]*)/.exec(search);
      if (formIDMatch) formID = formIDMatch[1];
      const tenantIDMatch = /tenant_id=([^?&]*)/.exec(search);
      if (tenantIDMatch) tenantID = tenantIDMatch[1];
      const equipmentIDMatch = /equipment_id=([^?&]*)/.exec(search);
      if (equipmentIDMatch) equipmentID = equipmentIDMatch[1];
    }
    return { fromQR, linkID, hasPrefill, formID, tenantID, equipmentID };
  };
  return { getRequiredDataFromURL };
};
